export const TABLE_FIRST_PAGE = 1;

// скачивание звонков (для списка звонков)
export const exportsActions = ['audio_archive', 'stt_export', 'xlsx_export'];
